import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';
import Button from '~/components/commonUi/Button/Button';
import Input from '~/components/commonUi/Input/Input';
import Modal from '~/components/commonUi/Modal/Modal';
import { Election } from '~/definitions/election';

interface Props {
    election: Election | null;
    isOpen: boolean;
    onClose: () => void;
    onSave: (name: string) => void;
}

const DIALOG_ID = 'form-copy-election';

const CopyElection = ({ election, isOpen, onClose, onSave }: Props) => {
    const [electionName, setElectionName] = useState<string>('');

    useEffect(() => {
        setElectionName(election?.name || '');
    }, [election?.name]);

    const handleSubmit = () => {
        onSave(electionName);
        onClose();
    };

    return (
        <form action="" method="post" onSubmit={handleSubmit}>
            <Modal id={DIALOG_ID} isOpen={isOpen} onClose={onClose}>
                <>
                    <div className="w-7/12 flex gap-2 pr-4">
                        <label className="w-5/12 font-normal content-center" htmlFor="company_name">
                            Nytt valg navn
                            <span className="text-red-600">*</span>
                        </label>
                        <div className="w-7/12">
                            <Input
                                id="company_name"
                                name="company_name"
                                extendedClassName="w-full"
                                onChange={(e) => setElectionName(e.target.value)}
                                value={electionName}
                                testId="company-name-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="w-5/12 flex gap-1 pl-4">
                        <Button type="submit" size="small" btnText="Lagre" testId="btn-save" />
                        <Button size="small" btnText="Avbryt" testId="btn-cancel" onClick={onClose} />
                    </div>
                </>
            </Modal>
        </form>
    );
};

const CopyElectionWithStore = () => {
    const { adminStore } = getStore();

    if (!adminStore.isCopyElectionModalOpen) {
        return null;
    }

    const handleClose = () => adminStore.setIsCopyElectionModalOpen(false);

    const handleSave = (name: string) => {
        const election_id = adminStore.electionToCopy?.id || '';
        adminStore.copyElection({ name, election_id });
    };

    return (
        <CopyElection
            election={adminStore.electionToCopy}
            isOpen={adminStore.isCopyElectionModalOpen}
            onClose={handleClose}
            onSave={handleSave}
        />
    );
};

export default observer(CopyElectionWithStore);
